/* Bouton de réouverture du popup newsletter.
   Indépendant de theme.js — jamais modifié. Utilise son propre flag
   (sessionStorage) car le cookie natif du popup (data-cookie-name,
   valeur "user_has_closed") est écrit à l'identique en cas de fermeture
   ET en cas de succès d'inscription (voir theme.dev.js, classe Newsletter,
   showMessage()) : impossible de s'y fier seul pour distinguer les deux.
   Seule la classe .has-success sur [data-newsletter-form] est fiable.

   IMPORTANT — pourquoi ce fichier ferme le popup lui-même (pas seulement
   la pastille) : theme.js n'attache ses propres écouteurs croix/fond gris
   QUE SI le cookie natif n'existe pas encore au chargement de la page
   (LargePopup.init() : "if (!cookieExists || designMode) { initClosers() }").
   Une visiteuse qui a déjà fermé le popup une fois a ce cookie posé — au
   rechargement suivant, le natif ne branche RIEN. Si on rouvre alors via
   ce bouton et qu'on ne compte que sur le natif pour refermer, clic sur
   croix/fond = plus aucun effet (bug vérifié en direct le 28/09). Ce
   fichier retire donc lui-même popup--visible, sans dépendre de l'état
   d'initialisation du natif. Idempotent si le natif agit aussi. */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'bymee_reopen_tab_';
  var buttons = document.querySelectorAll('[data-reopen-tab]');
  if (!buttons.length) return;

  buttons.forEach(function (btn) {
    var targetId = btn.getAttribute('data-reopen-target');
    var blockId = btn.getAttribute('data-reopen-block');
    var popup = document.getElementById(targetId);
    if (!popup) return;

    var storageKey = STORAGE_PREFIX + blockId;
    var form = popup.querySelector('[data-newsletter-form]');
    var closeBtn = popup.querySelector('[data-popup-close]');
    var underlay = popup.parentNode.querySelector('[data-popup-underlay]');

    function estSoumis() {
      return !!(form && form.classList.contains('has-success'));
    }

    function afficher(v) {
      btn.hidden = !v;
      if (v) {
        window.sessionStorage.setItem(storageKey, '1');
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    }

    // Redirection de succès (?customer_posted=true) détectée au chargement
    // -> jamais afficher, on efface un flag qui aurait pu rester d'avant.
    if (estSoumis()) {
      afficher(false);
      return;
    }

    // Fermé sans soumettre lors d'une page précédente (même session) -> réaffiche direct.
    if (window.sessionStorage.getItem(storageKey) === '1') {
      btn.hidden = false;
    }

    function fermerPopup() {
      popup.classList.remove('popup--visible');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }

    function surFermeture() {
      fermerPopup();
      afficher(!estSoumis());
    }

    if (closeBtn) closeBtn.addEventListener('click', surFermeture);
    if (underlay) underlay.addEventListener('click', surFermeture);

    document.addEventListener('keyup', function (e) {
      if ((e.key === 'Escape' || e.code === 'Escape') && popup.classList.contains('popup--visible')) {
        surFermeture();
      }
    });

    btn.addEventListener('click', function () {
      popup.classList.add('popup--visible');
      var body = popup.querySelector('[data-popup-body]');
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: body}));
      afficher(false);
    });
  });
})();
